import { VEBYearlyOpenAndCurrentEffectiveDate } from "../../constants/VEBYearlyOpenAndCurrentDate";

const parseMMDDYYYY = (dateStr: string): Date => {
	const [month, day, year] = dateStr.split("-");
	return new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
};

const calculateAge = (birthDate: string, otherDate: string | Date): number => {
	// const birthday = new Date(birthDate);
	// const ageDifMs = new Date(otherDate).getTime() - birthday.getTime();
	// const ageDate = new Date(ageDifMs); // miliseconds from epoch
	// console.log("Age 222 2222555", ageDate.getUTCFullYear());
	// return Math.abs(ageDate.getUTCFullYear() - 1970);/
	const _birthDate = new Date(birthDate);
	const refDate = new Date(otherDate);

	let age = refDate.getFullYear() - _birthDate.getFullYear();

	const monthDiff = refDate.getMonth() - _birthDate.getMonth();

	if (monthDiff < 0 || (monthDiff === 0 && refDate.getDate() < _birthDate.getDate())) {
		age--;
	}
	// console.log("Age 222 2222555", age);
	return age;

	// const _birthDate = new Date(birthDate);
	// const _otherDate = new Date(otherDate);

	// let years = _otherDate.getFullYear() - _birthDate.getFullYear();

	// if (
	// 	_otherDate.getMonth() < _birthDate.getMonth() ||
	// 	(_otherDate.getMonth() == _birthDate.getMonth() && _otherDate.getDate() < _birthDate.getDate())
	// ) {
	// 	years--;
	// }

	// return years;
};

export const calculateAgeDynamicV2 = (birthDate: string, otherDate: string | Date = new Date()): number => {
	const _birthDate = new Date(birthDate);

	// Normalize otherDate to UTC
	const otherDateObj = otherDate instanceof Date ? otherDate : parseMMDDYYYY(otherDate);
	const _otherDate = new Date(
		Date.UTC(otherDateObj.getUTCFullYear(), otherDateObj.getUTCMonth(), otherDateObj.getUTCDate())
	);

	let years = _otherDate.getUTCFullYear() - _birthDate.getUTCFullYear();

	// Subtract 1 if birthday hasn't been reached yet this year
	if (
		_otherDate.getUTCMonth() < _birthDate.getUTCMonth() ||
		(_otherDate.getUTCMonth() === _birthDate.getUTCMonth() && _otherDate.getUTCDate() < _birthDate.getUTCDate())
	) {
		years--;
	}

	return years;
};
export const getAgeInDays = (dateOfBirth: string) => {
	const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
	const firstDate = new Date(dateOfBirth);
	const secondDate = new Date("2025-03-01");

	const diffDays = Math.round(
		Math.abs(((firstDate as unknown as number) - (secondDate as unknown as number)) / oneDay)
	);
	return diffDays;
};
export const getAgeInDaysWholeLife = (dateOfBirth: string) => {
	const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
	const firstDate = new Date(dateOfBirth);
	const secondDate = new Date("2026-05-01");

	const diffDays = Math.round(
		Math.abs(((firstDate as unknown as number) - (secondDate as unknown as number)) / oneDay)
	);
	return diffDays;
};
export const getAgeInDaysV2 = (dateOfBirth: string) => {
	const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
	const firstDate = new Date(dateOfBirth);
	const secondDate = new Date(VEBYearlyOpenAndCurrentEffectiveDate.veb_yearly_open_effective_date_YYYYMMDD);

	const diffDays = Math.round(
		Math.abs(((firstDate as unknown as number) - (secondDate as unknown as number)) / oneDay)
	);
	return diffDays;
};
export const findAgeRange = (age: number, ranges: string[]) => {
	for (const range of ranges) {
		const [min, max] = range.split(/[-,*/]/).map(Number);
		if (age >= min && age <= max) {
			return range;
		}
	}
	return "Not in range";
};

export default calculateAge;
